var _style, _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{fill:none}.C{clip-rule:evenodd}.D{clip-path:url(#B)}.E{fill:#212b3e}.F{clip-path:url(#L)}.G{clip-path:url(#D)}.H{clip-path:url(#H)}.I{clip-path:url(#Y)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.142-263a32,32,0,0,1,32,32v3.523a6.859,6.859,0,0,1,5.714,6.762v8a6.859,6.859,0,0,1-5.889,6.789,32.021,32.021,0,0,1-18.11,25.559v10.508h2.286a41.142,41.142,0,0,1,41.142,41.142v5.143H32v-5.143a41.142,41.142,0,0,1,41.142-41.142h2.286v-10.508a32.022,32.022,0,0,1-18.111-25.56,6.858,6.858,0,0,1-5.889-6.789v-8a6.859,6.859,0,0,1,5.714-6.762V-231A32,32,0,0,1,89.142-263Z",
    transform: "translate(-32 263)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-113,356.117H813.276V-2101H-113Z",
    transform: "translate(113 2101)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h114.628v140.387H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-123.573H146.285V-263H32Z",
    transform: "translate(-32 263)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76-169a32,32,0,0,0,32,32,32,32,0,0,0,32-32h0v4.571a32,32,0,0,1-32,32,32,32,0,0,1-32-32Z",
    transform: "translate(-76 169)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.285-97.916c0,6.785,8.57,12.286,19.143,12.286s19.143-5.5,19.143-12.286a8.055,8.055,0,0,0-.215-1.846,41.144,41.144,0,0,1,37.929,41.018v5.113H32v-5.113A41.145,41.145,0,0,1,70.511-99.8,8.011,8.011,0,0,0,70.285-97.916Z",
    transform: "translate(-32 99.803)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h114.628v47.654H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-53.715H146.285V-100H32Z",
    transform: "translate(-32 100)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89-46.631c15.311-4.306 31.072-6.806 46.964-7.452.621-.025 1.144.349 1.144.816a.96.96 0 0 1-1.022.813c-4.785.2-25.535 1.3-44.4 5.824 0 .07-2.683.417-2.683 0m42.211-16.876a8.02 8.02 0 0 1 1.094-1.713c.1.052-.12.8-.7 1.808a12.49 12.49 0 0 1-1.709 2.3c.12-.294.871-1.618 1.316-2.395m-31.488.8c.361-.063.732.01 1.042.206.43.322.747.772.906 1.286a2.39 2.39 0 0 1-.513 1.75c-.41.577-.905 1.491-1.144 1.915-.154.282-.343.437-.667.153-.261-.195-.413-.502-.41-.828a3.61 3.61 0 0 1 .786-1.8c.427-.661.888-1.44.649-1.571-.632-.358-4.374 2.536-4.459 4.426-.052 1.085 2.289 1.708 2.955 2.078a.9.9 0 0 1 .513.765c-.068.524-.302 1.013-.667 1.395-.604.649-1.426 1.052-2.309 1.131a5.33 5.33 0 0 1-4.255-1.6c-.239-.247-.119-.442.12-.555a2.56 2.56 0 0 1 .53-.119 1.99 1.99 0 0 1 1.332.233c.798.618 1.776.96 2.785.973.336-.023.655-.157.907-.38a.43.43 0 0 0-.018-.684c-1.23-.752-3.6-1.322-3.6-2.988 0-2.221 2.665-4.516 4.2-5.339.403-.235.85-.388 1.313-.448zm32.018-3.924c.324-.353.632-.491.957-.24.359.259.569.676.563 1.119a2.19 2.19 0 0 1-.1.7c-.75 2.124-2.104 3.983-3.895 5.348a6.74 6.74 0 0 0-.564 2.214c0 .392.1.656.325.627.786-.1 1.777-1.328 2.426-2.59.05-.105.123-.198.214-.271a26.45 26.45 0 0 1 1.221-1.764c-.192-.125-.312-.334-.324-.562.153-.954.758-1.776 1.623-2.206.359-.047.512.129.512.5-.036.462-.14.915-.307 1.347.506-.211.974-.504 1.384-.868.291-.234.461-.289.683-.106a1.39 1.39 0 0 1 .5.98 1.12 1.12 0 0 1-.273.672c-.922 1.135-1.9 2.553-1.9 3.517 0 .425.137.668.376.636.581-.076 1.265-1.08 1.794-2.278.137-.312.376-.36.53-.086a1.31 1.31 0 0 1-.051 1.069 3.3 3.3 0 0 1-2.391 1.949 1.3 1.3 0 0 1-1.606-1.373c0-1.045.905-2.423 1.76-3.532a4.1 4.1 0 0 1-1.247.426c-1.032 1.588-1.87 3.294-2.495 5.082-.068.3-.29.479-.6.209a1.07 1.07 0 0 1-.407-.7c-.415.3-.895.499-1.4.583a1.3 1.3 0 0 1-1.6-.86c-.572.731-1.385 1.235-2.294 1.423-1.162.153-1.794-.368-1.794-1.25a2.78 2.78 0 0 1 .256-1.1c.273-.592.838-1.548 1.23-2.188.376-.589.786-1.133.649-1.115s-.5.228-1.5 1.325c-1.211 1.405-2.181 3.001-2.87 4.723-.171.334-.41.414-.683.188a.95.95 0 0 1-.376-.849 4.23 4.23 0 0 1 .308-1.25 17.4 17.4 0 0 1 1.263-2.322c.462-.8.94-1.48.786-1.459a6 6 0 0 0-1.827 1.678c-1.018 1.299-1.836 2.743-2.425 4.284-.12.278-.308.4-.6.194a.93.93 0 0 1-.294-.325 3.19 3.19 0 0 1-1.534.73c-1.008.133-1.522-.274-1.589-1a3.7 3.7 0 0 1-2.221 1.42c-.454.117-.925-.122-1.1-.557a3.72 3.72 0 0 1-1.924 1 1.36 1.36 0 0 1-1.692-1.46 8.25 8.25 0 0 1 1.846-3.706c-.419.222-.868.38-1.333.47-1.23 2.775-3.144 5.248-5.313 5.534A1.9 1.9 0 0 1 100-54.625a4.56 4.56 0 0 1 .512-1.946c.906-1.786 2.255-2.878 3.246-3.009.201-.038.408-.02.6.052.413.151.767.432 1.008.8.256.489-.017 1.113-.343 1.793a6.03 6.03 0 0 0-.307.71c-.12.359-.188.449-.615.293-.37-.125-.614-.478-.6-.868.075-.42.207-.828.393-1.212.17-.366.341-.715.256-.769-.223-.134-1.316 1.007-2.033 2.489-.301.584-.476 1.226-.513 1.882 0 .686.291 1.1.786 1.072 1.674-.156 3.5-2.781 4.39-4.907a.62.62 0 0 1-.478-.655 3.11 3.11 0 0 1 1.709-2.3c.359-.047.5.147.5.506a5.19 5.19 0 0 1-.324 1.415c.543-.214 1.046-.518 1.487-.9.256-.213.53-.315.752-.116.297.268.471.648.479 1.048a1.11 1.11 0 0 1-.291.692 10.67 10.67 0 0 0-1.845 2.987 2.39 2.39 0 0 0-.137.753c0 .408.137.635.393.618.541-.026 1.417-1.045 1.95-2.15a21.45 21.45 0 0 1 2.288-4.338.45.45 0 0 1 .735-.1c.172.199.263.455.256.718 0 .67-1.248 2.729-1.845 4.066-.308.694-.359 1.3.017 1.255.444-.059 1.35-1.288 2.221-2.71 1.008-1.7 1.452-2.87 2.066-3.7.24-.342.513-.443.718-.193a1.2 1.2 0 0 1 .256.816c-.134.846-.461 1.65-.957 2.348a7.5 7.5 0 0 0-1.161 2.668c0 .295.1.444.325.415.413-.054.99-.737 1.512-1.534.727-1.733 1.593-3.405 2.588-5 .222-.339.478-.358.649-.086a1.35 1.35 0 0 1 .239.753c-.002.151-.019.301-.052.448a5.35 5.35 0 0 1 2.239-1.6c.546-.072.905.469.905 1.155a5.15 5.15 0 0 1 2.221-1.485c.5-.049.768.356.768.9a5.54 5.54 0 0 1-1.059 2.475 4.92 4.92 0 0 0-.923 2.114c0 .376.171.615.445.58.53-.07 1.366-1.324 2-2.4a.65.65 0 0 1 .133-.168 21.33 21.33 0 0 1 4.182-7.682z",
    transform: "translate(-89 67)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.114-150.784a10.86 10.86 0 0 0 21.59-.05 1.2 1.2 0 0 0-1.061-1.166h-19.4a1.22 1.22 0 0 0-1.129 1.216z",
    transform: "translate(-113.11 152)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.895v12.88H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113-141.572h21.714V-153H113Z",
    transform: "translate(-113 153)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.857-163h12a2.86 2.86 0 0 1 2.857 2.857v3.429a2.86 2.86 0 0 1-2.857 2.857h-12a2.86 2.86 0 0 1-2.857-2.857v-3.429a2.86 2.86 0 0 1 2.857-2.857z",
    transform: "translate(-117 163)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.286-128.429a6.286,6.286,0,0,0,6.286-6.286A6.286,6.286,0,0,0,122.286-141,6.286,6.286,0,0,0,116-134.714,6.286,6.286,0,0,0,122.286-128.429Z",
    transform: "translate(-116 141)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.286-128.429a6.286,6.286,0,0,0,6.286-6.286A6.286,6.286,0,0,0,132.286-141,6.286,6.286,0,0,0,126-134.714,6.286,6.286,0,0,0,132.286-128.429Z",
    transform: "translate(-126 141)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120-169c0,2.525,3.07,4.571,6.857,4.571h0c3.787,0,6.857-2.047,6.857-4.571",
    transform: "translate(-120 169)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.857-185.286a6.86 6.86 0 0 0 6.857-6.857 6.86 6.86 0 0 0-6.857-6.857 6.86 6.86 0 0 0-6.857 6.857 6.86 6.86 0 0 0 6.857 6.857z",
    transform: "translate(-146 199)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.429-186.143a3.43 3.43 0 0 0 3.429-3.429 3.43 3.43 0 0 0-5.854-2.424 3.43 3.43 0 0 0 2.425 5.853z",
    transform: "translate(-152 193)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.092-186.316c1.195-2.306 3.595-3.734 6.192-3.684a6.83 6.83 0 0 1 6.182 3.661c.315.641-.133 1.166-.586.777a8.6 8.6 0 0 0-5.6-1.956c-1.978-.029-3.907.622-5.463 1.844-.505.417-1.034-.007-.725-.642z",
    transform: "translate(-92 190)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.272-207.212c.854-5.442 8.047-9.154 13.25-6.758.573.264 1.252.013 1.516-.56s.013-1.252-.56-1.516c-6.564-3.023-15.372 1.523-16.464 8.48-.098.624.329 1.208.952 1.306s1.208-.329 1.306-.952z",
    transform: "translate(-88 216.997)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.871-207.212c-.854-5.442-8.047-9.154-13.25-6.758-.573.264-1.252.013-1.516-.56s-.013-1.252.56-1.516c6.564-3.023 15.372 1.523 16.464 8.48.098.624-.329 1.208-.952 1.306s-1.208-.329-1.306-.952z",
    transform: "translate(-146 216.997)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-139H150.856V-299H0Z",
    transform: "translate(0 299)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h66.974v96.596H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.53-159.761a5.21 5.21 0 0 1-4.9 1.488c-.333-.071-1.689-2.593-5.059-2.593s-4.726 2.522-5.059 2.593a5.21 5.21 0 0 1-4.9-1.488c-2.7-2.465-4.945-5.863-3.6-9.571.7-1.933 1.847-4.055 3.927-4.67 2.222-.657 5.341 0 7.579-.45.737-.118 1.438-.403 2.049-.833.611.43 1.311.714 2.048.833 2.239.449 5.358-.207 7.58.45 2.08.616 3.224 2.738 3.927 4.67 1.349 3.708-.9 7.106-3.6 9.571M139.617-201c-1.949 4.8-1.2 10.776-1.557 15.815-.293 4.1-1.154 10.234-4.791 12.879-1.86 1.353-5.245 3.626-7.675 2.992-1.673-.436-1.851-5.234-4.049-7.03a12.81 12.81 0 0 0-8.746-2.794c-1.355.06-4.094.045-5.228 1.087-1.134-1.042-3.873-1.028-5.228-1.087a12.81 12.81 0 0 0-8.746 2.794c-2.2 1.8-2.376 6.594-4.049 7.03-2.43.634-5.815-1.639-7.675-2.992-3.637-2.645-4.5-8.783-4.791-12.879-.36-5.039.392-11.015-1.557-15.815-.948 0-.323 9.216-.323 9.216v11.632c.018 8.736 5.475 21.811 17.574 26.8 2.959 1.221 9.661 3.2 14.8 3.2a46.5 46.5 0 0 0 14.8-3.015c12.1-4.993 17.555-18.257 17.574-26.993v-11.632s.625-9.216-.323-9.216",
    transform: "translate(-75 201)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-130.859H146.285V-280H32Z",
    transform: "translate(-32 280)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h68.262v51.518H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74-150.143h66.285V-201H74Z",
    transform: "translate(-74 201)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.181-279.787c1.081-.378 2.282-.153 3.152.591l.246.149a3.57 3.57 0 0 0 2.452.7c1.651-.257 2.1-.467 3.587.473 1.446.912 1.79.26 3.427.247 1.157-.009 1.866.958 2.834 1.059.483.051.945-.452 1.463-.421 1.85.112 1.967 2.5 3.437 3.163 1.343.6 2.921-.244 4.254-.4 2.152-.252 1.9.992 1.518 2.388l-.079.281a6.1 6.1 0 0 0-.322 1.8c1.276.3 2.572-.893 3.842-.674 1.841.318 1.349 2.1.9 3.47l-.059.176-.057.171c1.386-.025 5.005-1.564 5.9.4.463 1.015-.616 2.37-.6 3.4.025 1.452 1.092 2.654 1.469 4.028.51 1.855 1.236 6.828-.042 8.476-.426.55-3.338-.994-4.552-1.664-10.2-5.634-12.177-7.426-28.243-7.192s-27.073 7.761-27.692 8.531c-.431.536-.981 1.966-1.433 5.95-.125 1.1-.171 2.443-.207 3.809l-.015.586c-.086 3.388-.169 6.732-1.289 6.726-.794 0-1.235-4.419-1.355-9.214l-.011-.506h0l-.009-.508h0l-.007-.508q0-.127 0-.254v-.507q0-.127 0-.253v-.5c.007-2.6.107-5.055.293-6.726.235-.999.3-2.031.191-3.052-.225-.65-1.327-.649-1.151-1.732.12-.74.615-.815 1.11-.885l.164-.024a1.15 1.15 0 0 0 .711-.3c1.025-1.117-.556-1.381-.819-2.358-.334-1.245.446-1.7 1.315-2.091l.437-.195c1.124-.507.978-.062 1.89-1.055-1.218-.893-1.659-2.109.009-2.762.708-.277 2.551.09 3.106-.327.145-.109.2-.731.291-.858.886-1.268.668-2.186.578-3.609-.074-1.165-.064-2.234 1.33-2.35.931-.078 1.687.683 2.521.906.925.248.577.43 1.3-.069 1.272-.876.406-2.583 1.415-3.6 1.384-1.4 2.292.651 3.4.806 1.477.206 1.76-.633 2.085-1.52l.066-.178a2.44 2.44 0 0 1 .916-1.314 1.16 1.16 0 0 1 1.786.346l.1.13.049.066.1.132c.261.348.526.666.905.7.924.062 2.588-1.722 3.393-2.054zm32.962 29.692c.483-.592.951-.249 1.54-.012a21.85 21.85 0 0 1 2.363 1.494c1 .565 1.8 6.228 1.838 8.394.024 1.336.046 6.432-1.368 5.992-.43-.134-1.087-2.832-1.18-4.411s-.99-6.951-2.366-9.422c-.316-.565-1.216-1.557-.827-2.035z",
    transform: "translate(-72 280)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h69.549v47.654H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71-233.143h68V-280H71Z",
    transform: "translate(-71 280)",
    className: "B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E20360",
    d: "M0 0h160v160H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.858 20.572)",
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.856 -1050.275)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.602 1050.309)",
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.254 -.035)",
    className: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h115.427v140.57H-.571z",
    fill: "#cfc6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h115.427v140.57H-.571z",
    fill: "#d08a5a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.397 53.679)",
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.143 -53.714)",
    className: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.571 53.142h65.142v37.714H24.571z",
    fill: "rgba(0,0,0,0.1)"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.858 113.826)",
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.856 -1143.529)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.602 1143.044)",
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.254 .373)",
    className: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h115.427v47.428H-.571z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h115.427v47.428H-.571z",
    fill: "#c000ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.825 19.23)",
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.571 -18.857)",
    className: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 18.163h49.761v22.052H32z",
    fill: "#fff"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.206 84)",
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-129.204 -1113.703)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.968 1112.132)",
    clipPath: "url(#K)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.173 .999)",
    className: "F E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h22.857V12H-.571z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.459 -4.715)",
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.286 5.714)",
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.714-.571h18.857V4H1.714z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.887 7.856)",
    clipPath: "url(#N)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.714 -6.857)",
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.143 6.286h13.714V12H1.143z",
    fill: "#ff4f6c"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.602 7.856)",
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.428 -6.857)",
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.857 6.286h13.714V12H6.857z",
    fill: "#ff4f6c"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.143 74.286)",
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-133.141 -1103.988)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.57 1103.417h14.857v5.714H132.57z",
    fill: "rgba(0,0,0,0.16)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(88 57.143)",
    clipPath: "url(#Q)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-147.998 -1086.846)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.427 1086.274h14.857v14.857h-14.857z",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.428 60.572)",
    clipPath: "url(#R)",
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-151.427 -1090.274)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.856 1089.703h8v8h-8z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.143 62.286)",
    clipPath: "url(#S)",
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117.142 -1091.988)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.353 1091.417h14.141v5.97h-14.141z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.857 46.859)",
    clipPath: "url(#T)",
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-114.856 -1076.562)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.201 1073.919h18.529v14.049h-18.529z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.999 46.859)",
    clipPath: "url(#U)",
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-147.998 -1076.562)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.267 1087.969h18.529v-14.049h-18.529z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.572 .001)",
    clipPath: "url(#V)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.215 10.303)",
    clipPath: "url(#W)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.642 45.696)",
    clipPath: "url(#X)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.571 -45.142)",
    className: "I"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.929 44.526)",
    clipPath: "url(#Z)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.071 .617)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h67.428v52H-.571z",
    fill: "#331b0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h67.428v52H-.571z",
    className: "E"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.072 .554)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.857)",
    className: "I"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.641 -.554)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.644 .554)",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h69.142v48H-.571z",
    fill: "#2d3156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h69.142v48H-.571z",
    fill: "#242b3d"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp07);
export default __webpack_public_path__ + "static/media/scrumlr-lp-07.23c1bb610698ad18a44438621bc0fa84.svg";
export { ForwardRef as ReactComponent };